import { render, staticRenderFns } from "./Stablishment.vue?vue&type=template&id=2d20c25c&"
import script from "./Stablishment.vue?vue&type=script&lang=js&"
export * from "./Stablishment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports